import PdfIcon from '@mui/icons-material/PictureAsPdfSharp';
import HtmlIcon from '@mui/icons-material/HtmlSharp';
import DocumentIcon from '@mui/icons-material/DocumentScannerSharp';
import ZipIcon from '@mui/icons-material/FolderZipSharp';
import ImageIcon from '@mui/icons-material/ImageSharp';
import TextIcon from '@mui/icons-material/TextSnippetSharp';
import CodeIcon from '@mui/icons-material/CodeSharp';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { ReactElement } from 'react';

type FontSize = 'inherit' | 'small' | 'medium' | 'large';
type Color = 'inherit' | 'primary' | 'secondary' | 'action' | 'error' | 'disabled';
export function selectIconFromMimeType(
  mimeType: string,
  fontSize: FontSize = 'medium',
  color: Color = 'primary'
): ReactElement {
  switch (mimeType) {
    case 'application/pdf':
      return <PdfIcon color={color} fontSize={fontSize} />;
    case 'text/html':
      return <HtmlIcon color={color} fontSize={fontSize} />;
    case 'application/msword':
    case 'application/vnd.ms-excel':
    case 'application/vnd.ms-excel.sheet.binary.macroEnabled.12':
    case 'application/vnd.ms-excel.sheet.macroEnabled.12':
    case 'application/vnd.ms-officetheme':
    case 'application/vnd.ms-outlook':
    case 'application/vnd.ms-powerpoint':
    case 'application/vnd.ms-powerpoint.presentation.macroEnabled.12':
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return <DocumentIcon color={color} fontSize={fontSize} />;
    case 'application/x-zip-compressed':
    case 'application/zip':
      return <ZipIcon color={color} fontSize={fontSize} />;
    case 'image/gif':
    case 'image/jpeg':
    case 'image/png':
    case 'image/svg+xml':
    case 'image/tiff':
      return <ImageIcon color={color} fontSize={fontSize} />;
    case 'message/rfc822':
    case 'text/calendar':
    case 'text/csv':
    case 'text/plain':
      return <TextIcon color={color} fontSize={fontSize} />;
    case 'text/xml':
      return <CodeIcon color={color} fontSize={fontSize} />;
    default:
      return <QuestionMarkIcon color={color} fontSize={fontSize} />;

  }
}
